import { jsxs as _, jsx as l } from "react/jsx-runtime";
import "react";
import { GridList as m } from "../GridList/GridList.js";
import { LogoListItem as r } from "../LogoListItem/LogoListItem.js";
import { classes as a } from "../../utils/helpers.js";
import '../../assets/DeviceAndPlatformLists.css';const t = {
  "devices-platforms": "_devices-platforms_1jzzl_1",
  "devices-platforms__column": "_devices-platforms__column_1jzzl_5",
  "devices-platforms__column-item": "_devices-platforms__column-item_1jzzl_12"
};
function z({ platformResources: s }) {
  let o = s.size < 4 ? s.size : Math.ceil(s.size / 2);
  const c = [...s.entries()];
  [...s.keys()][0].slug === "video-platforms" && (o = 1);
  const n = c.slice(0, o), d = c.slice(o, s.size);
  return /* @__PURE__ */ _("section", { className: a([t["devices-platforms"], "devices-platforms"]), children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: a([t["devices-platforms__column"], "devices-platforms__column"]),
        style: {
          gridColumn: s.size >= 4 ? "1/2" : "1/3"
        },
        children: n.map((i) => /* @__PURE__ */ l("div", { className: a([t["devices-platforms__column-item"], "devices-platforms__column-item"]), children: /* @__PURE__ */ l(m, { headerText: i[0].name.toLowerCase(), children: i[1].map((e) => /* @__PURE__ */ l(
          r,
          {
            imageSource: e.image_url,
            altText: e.alt_text,
            href: e.link,
            target: (e == null ? void 0 : e.target) ?? "_blank"
          },
          `sd-${e.id}`
        )) }) }, `${i[0].slug}`))
      }
    ),
    s.size >= 4 && /* @__PURE__ */ l(
      "div",
      {
        className: a([t["devices-platforms__column"], "devices-platforms__column"]),
        style: {
          gridColumn: "2/3"
        },
        children: d.map((i) => /* @__PURE__ */ l("div", { className: a([t["devices-platforms__column-item"], "devices-platforms__column-item"]), children: /* @__PURE__ */ l(m, { headerText: i[0].name.toLowerCase(), children: i[1].map((e) => /* @__PURE__ */ l(
          r,
          {
            imageSource: e.image_url,
            altText: e.alt_text,
            href: e.link,
            target: (e == null ? void 0 : e.target) ?? "_blank"
          },
          `sd-${e.id}`
        )) }) }, `${i[0].slug}`))
      }
    )
  ] });
}
export {
  z as DeviceAndPlatformLists,
  z as default
};
